import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import styled from 'styled-components';
import { Analytics } from '@vercel/analytics/react';
import i18n from './i18n';
import { theme } from './styles/theme';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ProductInquiryPage from './pages/ProductInquiryPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import { usePageTracking } from './hooks/usePageTracking';

const MainContent = styled.main<{ $isHomePage: boolean; $isAdminPage: boolean }>`
  padding-top: ${props => {
    if (props.$isAdminPage) return '0';
    if (props.$isHomePage) return '0';
    return '80px';
  }};
`;

const AppContent: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isAdminPage = location.pathname.startsWith('/admin');

  // Track page views
  usePageTracking();

  return (
    <div className="App">
      <Analytics />
      {!isAdminPage && <Header />}
      <MainContent $isHomePage={isHomePage} $isAdminPage={isAdminPage}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:id" element={<NewsDetailPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:id" element={<ProductDetailPage />} />
          <Route path="/inquiry" element={<ProductInquiryPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        </Routes>
      </MainContent>
      {!isAdminPage && <Footer />}
    </div>
  );
};

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Router>
          <AppContent />
        </Router>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
